import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'ニッセンオンライン',
  title1: 'ニッセンオンライン',
  introduction_text:
    'ECサイトのスピーディーなSEO改修を実現いたしました。このプロジェクトでは、弊社の自社プロダクト"flamingo"をご導入いただき、効率的なPDCAを回せないという課題を解決いたしました。',
  company: '株式会社ニッセン',
  tag1text: 'UX/UI改善',
  tag1src: '/cases/uxui-improvement/',
  tag2text: 'flamingo',
  tag2src: '/cases/flamingo/',
  industryTagText: '小売/流通/卸',
  industryTagSrc: '/cases/retail/',
  color: '',
  background: '#CFE777',
  staff1: '',
  image: '/images/img/cases/caseStudyTop/nissen.webp',
  alt: 'ニッセンオンライン',
  imgClass: 'fv_img_adjust1',
}

// プロジェクト概要
export const overviewTitle = 'SEO改修のPDCAサイクルを“flamingo”で改善'
export const overviewItem: OverviewItems[] = [
  {
    text: '婦人服を中心とした衣料品やインテリア雑貨の通販会社ニッセン様では、SEOの改修について素早くPDCAを回すことに課題を持たれていました。この課題に対してスピーディかつ低コストで対応できることから、同社では"flamingo"をご導入いただきました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '改修しにくい複雑な仕組み',
        text: '',
      },
      {
        title: 'SEO改修が思うように進まない',
        text: '',
      },
      {
        title: '効率的なPDCAを回せていない',
        text: '',
      },
    ],
    solutions: [
      {
        title: '仕組みに影響せずSEO対策出来るプロダクト"flamingo"の導入',
        text: '',
      },
      {
        title: 'その結果、スピーディーなSEO改修を実現',
        text: '',
      },
      {
        title: 'マーケティングの全体最適化を実現',
        text: '',
      },
    ],
  },
]

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
